import { SupportedLocale, getCountryCode, getLanguageCode } from '@99designs/i18n';
import type { DesignProductSearchResult } from '../../../types/Search';

export const getProductSearchResultsDisplayedTracking = ({
    query,
    results,
    locale,
}: {
    query: string;
    results: DesignProductSearchResult[];
    locale: SupportedLocale;
}) => ({
    query,
    sectionName: 'Product',
    applicationName: 'DesignServicesHubSearch',
    language: getLanguageCode(locale),
    locale: getCountryCode(locale),
    totalResultCount: results.length,
    resultsInSection: results.map((result) => ({
        resultSource: 'LocalPopularDesignableProducts',
        id: result.designProductPresenter.key,
    })),
    shownResultsInSection: results.slice(0, 5).map((result) => ({
        resultSource: 'LocalPopularDesignableProducts',
        id: result.designProductPresenter.key,
    })),
    resultsWithTyposCount: results.filter(
        (result) => !result.matches[0].value.toLowerCase().includes(query.toLowerCase())
    ).length,
});
